import { useState } from "react";

export interface FilterGroup {
  key: string;
  label: string;
  options: string[];
}

interface FilterBarProps {
  groups: FilterGroup[];
  values: Record<string, string>;
  onChange: (key: string, value: string) => void;
  onReset: () => void;
  activeCount: number;
}

export default function FilterBar({ groups, values, onChange, onReset, activeCount }: FilterBarProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="md:hidden w-full flex items-center justify-between px-4 py-3 cursor-pointer"
      >
        <span className="inline-flex items-center gap-2 text-sm font-medium text-foreground-900">
          <i className="ri-filter-3-line text-base w-4 h-4 flex items-center justify-center"></i>
          筛选条件{activeCount > 0 ? `（已选 ${activeCount}）` : ""}
        </span>
        <i
          className={`text-xl w-5 h-5 flex items-center justify-center ${
            open ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"
          }`}
        ></i>
      </button>

      <div className={`${open ? "block" : "hidden"} md:block p-4 pt-0 md:pt-4`}>
        <div className="flex flex-col gap-3">
          {groups.map((group) => (
            <div key={group.key} className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
              <span className="shrink-0 text-xs md:text-sm font-medium text-foreground-500 sm:w-16">
                {group.label}
              </span>
              <div className="flex flex-wrap gap-2">
                {group.options.map((option) => {
                  const active = (values[group.key] || "全部") === option;
                  return (
                    <button
                      key={option}
                      type="button"
                      onClick={() => onChange(group.key, option)}
                      className={`rounded-full px-3 py-1 text-xs transition-colors cursor-pointer whitespace-nowrap ${
                        active
                          ? "bg-primary-500 text-foreground-950 font-bold"
                          : "bg-background-100 text-foreground-600 hover:bg-background-200"
                      }`}
                    >
                      {option}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {activeCount > 0 && (
          <div className="mt-3 pt-3 border-t border-background-200">
            <button
              type="button"
              onClick={onReset}
              className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-600 hover:text-accent-700 transition-colors cursor-pointer"
            >
              <i className="ri-close-circle-line w-4 h-4 flex items-center justify-center"></i>
              清空筛选条件
            </button>
          </div>
        )}
      </div>
    </div>
  );
}